import React from "react";
import "./Newsletter.css";
import { useFormik } from "formik";
import * as yup from "yup";
import { WithTransLate } from "./../../translating/index";

const NewsLetter = () => {
  const validationSchema = yup.object({
    name: yup
      .string("Enter your full name")
      .min(4, "Too short!")
      .max(100, "Too Long!")
      .required("Your full name is required"),
    email: yup
      .string("Enter your email")
      .max(255, "Too Long!")
      .email("Enter a valid email")
      .required("Email is required"),
  });

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      console.log(JSON.stringify(values, null, 2));
    },
  });

  console.log();

  return (
    <div className="newsletter_container">
      <h4>
        {" "}
        <WithTransLate text="Sign up to the BH newsletter to get our updates from Iceland"></WithTransLate>
      </h4>

      {"  "}
      <form onSubmit={formik.handleSubmit} className="newsletter_form">
        <input
          value={formik.values.name}
          onChange={formik.handleChange}
          error={formik.touched.name && formik.errors.name ? true : undefined}
          helpertext={formik.touched.name && formik.errors.name}
          type="text"
          placeholder={WithTransLate({
            text: "Your full name",
            isFunction: true,
          })}
          name="name"
        />
        <input
        value={formik.values.lastname}
        onChange={formik.handleChange}
        error={formik.touched.name && formik.errors.name ? true : undefined}
        helpertext={formik.touched.lastname && formik.errors.lastname}
        type="text"
        placeholder={WithTransLate({
          text: "Your last name",
          isFunction: true,
        })}
        name="lastname"
      />
        <input
          value={formik.values.email}
          onChange={formik.handleChange}
          error={formik.touched.email && formik.errors.email ? true : undefined}
          helpertext={formik.touched.email && formik.errors.email}
          type="text"
          placeholder={WithTransLate({
            text: "Your email address",
            isFunction: true,
          })}
          name="email"
        />

        <button type="submit">
          <WithTransLate text="SIGN UP"></WithTransLate>
        </button>
      </form>
    </div>
  );
};

export default NewsLetter;
